// The shared frame of the custom field editors: a padded ~260px column with a right-aligned action
// row, the same shape as the Target Value editor so every inline editor on the list looks alike.
import Styled from 'styled-components';

export const Body = Styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 260px;
	padding: 16px;
`;
export const Actions = Styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 8px;
`;
